import { useTranslation } from "react-i18next";
import { InboxOutlined } from "@ant-design/icons";

import { UploadDragger } from "@av/components/atoms/upload/UploadDragger";
import { useCompanyKnowledgeStyles } from "../styles";

import type { UploadProps } from "antd";

type CompanyKnowledgeUploadProps = {
  errorId: string;
  fileInputTestId?: string;
  fileError?: string;
  testIdPrefix: string;
} & UploadProps;

export function CompanyKnowledgeUpload({
  errorId,
  fileInputTestId,
  fileError,
  testIdPrefix,
  ...uploadProps
}: CompanyKnowledgeUploadProps) {
  const { t } = useTranslation();
  const { styles } = useCompanyKnowledgeStyles();

  return (
    <UploadDragger
      accept=".pdf,application/pdf"
      accessibility={{
        label: t("platform.adminSettings.companyKnowledge_uploadLabel"),
        invalid: !!fileError,
        describedBy: fileError ? errorId : undefined,
      }}
      beforeUpload={() => false}
      className={styles.uploadDragger}
      fileInputTestId={fileInputTestId}
      maxCount={1}
      multiple={false}
      testIdPrefix={testIdPrefix}
      {...uploadProps}
    >
      <p className={`ant-upload-drag-icon ${styles.uploadIconWrapper}`}>
        <InboxOutlined className={styles.uploadIcon} />
      </p>
      <p className={`ant-upload-text ${styles.uploadPrimaryText}`}>
        <span className={styles.uploadPrimaryTextLine}>
          {t("platform.adminSettings.companyKnowledge_uploadPrimaryLine1")}
        </span>
        <span className={styles.uploadPrimaryTextLine}>
          {t("platform.adminSettings.companyKnowledge_uploadPrimaryLine2")}
        </span>
      </p>
      <p className="ant-upload-hint">{t("platform.adminSettings.companyKnowledge_uploadHint")}</p>
    </UploadDragger>
  );
}
